<template>
  <div>
    <v-container class="pl-10 pr-10 ml-0">
      <div v-if="is_load">
        <p class="display-1 mt-7">멤버십 회원 목록</p>
        <p class="mb-0 subtitle-1 font-weight-light">
          멤버십에 가입한 회원 목록을 확인이 가능합니다.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          멤버십 회원들에게 다양한 혜택/프로모션을 제공해보세요.
        </p>
      </div>

      <UserSearch ref="UserSearch"></UserSearch>
      <UserMemberList ref="UserMemberList"></UserMemberList>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<style scoped>
.container {
  max-width: 100%;
}
</style>
<script>
const UserSearch = () =>
  import(
    /* webpackChunkName: "ViewUserSearch" */ "@/components/membership/user/UserSearch.vue"
  );
const UserMemberList = () =>
  import(
    /* webpackChunkName: "ViewUserMemberList" */ "@/components/membership/user/UserMemberList.vue"
  );

import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data() {
    return {
      is_load: false,
    };
  },
  components: {
    UserSearch,
    UserMemberList,
    PageLoadingProgress,
  },
  methods: {
    serchShow: function() {
      this.progressHide();
      this.is_load = true;
      this.$refs.UserSearch.is_load = true;
      this.$refs.UserMemberList.is_load = true;
    },

    progressShow: function() {
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.$refs.PageLoadingProgress.hide();
    },
  },
  mounted: function() {
    this.progressShow();
  },
};
</script>
